import classes from "./SectorsWeCover.module.scss";

const sectors = [
  {
    title: "Energy",
    imageSrc:
      "https://se-website-image.s3.ap-south-1.amazonaws.com/landing-page/sectors-we-cover/energy.jpeg",
    description:
      "Enabling clean energy transitions, and building clean energy projects for a sustainable future",
  },
  {
    title: "AI",
    imageSrc:
      "https://se-website-image.s3.ap-south-1.amazonaws.com/landing-page/sectors-we-cover/ai.jpeg",
    description:
      "Exploring advancements, applications, and the future impact of artificial intelligence across industries",
  },
  {
    title: "Finance",
    imageSrc:
      "https://se-website-image.s3.ap-south-1.amazonaws.com/landing-page/sectors-we-cover/finance.jpeg",
    description:
      "Aiding financial institutions in finding bankable investment opportunities and decarbonizing their portfolio",
  },
];

function SectorsWeCover() {
  return (
    <div className={classes.container}>
      <div className={classes.title}>Sectors We Cover</div>

      <div className={classes["sector-cards"]}>
        {sectors.map((sector, index) => (
          <div key={index} className={classes["sector-card"]}>
            <div className={classes["card-top"]}>
              <img
                src={sector.imageSrc}
                alt={sector.title}
                className={classes["img"]}
              />
              <div className={classes["sector-title"]}>{sector.title}</div>
            </div>

            <div className={classes["description"]}>{sector.description}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SectorsWeCover;
